<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div class="barcode-item" fxLayout="column">
  <span class="barcode-value">{{ barcodeItem.barcode.value }}</span>
  <span *ngIf="barcodeItem.timestamp.value" class="scan-meta-data">{{
    customDateFormatService.formatDate(barcodeItem.timestamp.value)
  }}</span>
  <span
    class="scan-meta-data"
    *ngIf="barcodeItem.barcodeType.value === 'manual'"
    i18n="barcode selection type@@barcodeSelectionType"
    >manually selected</span
  >
</div>
